<template>
  <div class="searchAndQueryOfPropertyKnowledgeBaseList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="type" @change="showGarden">
            <el-option
              v-for="(item,index) in this.$i18n.t('lang.searchAndQueryOfPropertyKnowledgeBaseList.gender')"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="this.gardenId === 0">
          <el-select v-model="thisGardenId">
            <el-option key :label="$t('lang.villageall')" :value="0"></el-option>
            <el-option
              v-for="(item,index) in thisGardenIdList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="typelistValue">
            <el-option key :label="$t('lang.lab_allType')" :value='0'></el-option>
            <el-option
              v-for="(item,index) in typelistList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="knowledgeName" :placeholder="$t('lang.lbl_knowledge_inputktName')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <el-button type="success" @click="download">{{$t('lang.lab_uploadModel')}}</el-button>
        <el-upload
          v-if="this.gardenId === 0"
          class="upload-demo"
          ref="upload"
          :on-remove="handleRemove"
          :on-change="handleSuccess"
          :on-error="uploadErr1"
          accept=".xlsx,.xls"
          action
          :file-list="fileList"
          :limit= "1"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary" v-if="this.gardenId === 0">选取文件</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload" v-if="this.gardenId === 0">上传到服务器</el-button>
        </el-upload>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="outReuslt">{{$t('lang.btn_excelDl')}}</el-button>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_knowledge')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.knowledgeQuerysCbx"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="gname" :label="$t('lang.lbl_knowledge_gname')" width="150px">
          <template slot-scope="scope">
            <span v-if="scope.row.gname === null">
              全部小区
            </span>
            <span v-else>
              {{scope.row.gname}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="ktName" :label="$t('lang.lbl_knowledge_ktName')" width="200px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.ktName&&scope.row.ktName.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.ktName }}
                </span>
              </div>
              <div>
                {{ scope.row.ktName.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span
                  v-if="scope.row.ktName.length>require('@/config/enum').tableDatamaxlength10"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.ktName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('lang.lbl_knowledge_name')" width="400px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.name&&scope.row.name.length> require('@/config/enum').tableDatamaxlength25"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.name }}
                </span>
              </div>
              <div>
                {{ scope.row.name.substring(0, require('@/config/enum').tableDatamaxlength25) | valueIsNull }}
                <span
                  v-if="scope.row.name.length>require('@/config/enum').tableDatamaxlength25"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="answer" :label="$t('lang.lbl_knowledge_answer')" >
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.answer&&scope.row.answer.length> require('@/config/enum').tableDatamaxlength35"
              :disabled="false">
              <div slot="content">
                <span >
                  {{ scope.row.answer }}
                </span>
              </div>
              <div>
                {{ scope.row.answer.substring(0, require('@/config/enum').tableDatamaxlength35) | valueIsNull }}
                <span
                  v-if="scope.row.answer.length>require('@/config/enum').tableDatamaxlength35"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.answer | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2" v-if="this.gardenId === 0">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2" v-if="this.gardenId != 0 && this.showEdit">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      @closed="handleDialogClosed">
      <el-form :model="diaForm" :rules="rules" ref="diaForm" :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.diaFormtype')" v-if="this.gardenId === 0">
          <el-select v-model="diaForm.type" @change="showDialogGarden()">
            <el-option
              v-for="(item,index) in this.$i18n.t('lang.searchAndQueryOfPropertyKnowledgeBaseList.gender')"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormgardenId')" prop="gardenIdssasdfasdf" v-if="this.gardenId === 0 && diaForm.type === 1">
          <el-select v-model="diaForm.gardenId" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgardenId')" class="select">
            <el-option key :label="$t('lang.villageall')" value=''></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormgardenId')" prop="gardenId" v-if="this.gardenId === 0 && diaForm.type === 2">
          <el-select v-model="diaForm.gardenId" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgardenId')" class="select">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormgardenId')" value=''></el-option>
            <el-option v-for="(item, index) in thisDiaGardenIdList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormtypeId')" prop="typeId">
          <el-select v-model="diaForm.typeId" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormtypeId')" class="select">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormtypeId')" value=''></el-option>
            <el-option v-for="(item, index) in typeDialogList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormname')" prop="name">
          <el-input
            type="textarea"
            :rows="5"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.diaFormname')"
            maxlength="100"
            v-model="diaForm.name">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.diaFormanswer')" prop="answer">
          <el-input
            type="textarea"
            :rows="5"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.diaFormanswer')"
            maxlength="200"
            v-model="diaForm.answer">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('diaForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:searchAndQueryOfPropertyKnowledgeBaseList
 *@Description:物业知识库检索查询列表
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-20
 */
// 导入表格下载
import { excelDownload } from '../../../config/download.js'
import { mapGetters } from 'vuex'

export default {
  name:'/manage/main.knowledge',
  data() {
    var chooseGardenId = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.diaFormgardenId')))
      } else {
        callback()
      }
    }
    return {
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      tableDataAll: [], // 所有数据
      thisGardenId: 0, // 当前的小区ID
      showEdit: false, // 编辑功能的隐藏显示
      title: '', // 弹框的title
      saveData: '', // 存储json字符串
      thisGardenIdList: [], // 本页的小区ID列表
      thisDiaGardenIdList: [],
      fileLists: '',
      fileList: [], // 存储上传excel文件
      knowledgeQuerysCbx: require('@/config/enum').knowledgeQuerysCbx, // 是否隐藏复选框
      mouldKnowledge: require('@/config/enum').mouldKnowledge, // 知识库模板下载
      isDisabled: false, // 保存的可点击
      isPopupPage: false, // 弹框的显示控制
      editId: '', // 点击编辑是保存改行的id
      knowledgeName: '', // 查询的关键字keyword
      typeDialogList: [], // 弹框中存储分类的数组
      diaForm: {
        type: 2, // 物业问题/项目问题  1物业知识/2项目知识
        gardenId: '', // 所属小区
        typeId: '', // 问题分类
        name: '', // 问题
        answer: '', // 答案
      },
      rules: {
        gardenId: [
          { required: true, validator: chooseGardenId, trigger: 'change' }
        ],
        typeId: [
          { required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.diaFormtypeId'), trigger: 'change' }
        ],
        name: [
          { required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.diaFormname'), trigger: 'blur' }
        ],
        answer: [
          { required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.diaFormanswer'), trigger: 'blur' }
        ]
      },
      type: 1, // 物业知识百问下拉框的值   1物业知识/2项目知识
      typelist: [], // 物业问题/项目问题列表
      gardenIdlist: [], // 所属小区列表
      typeIdlist: [], // 问题分类列表
      typelistValue: 0, // 全部分类查询的value
      typelistList: [], // 全部分类查询的list
      name: '', // 问题
      answer: '', // 答案
    }
  },
  created () {
    this.getTablelist()
    this.getTableAllList()
    this.getTypeId()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    diaForm: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 上传文件的断网
    uploadErr1() {
      if (!navigator.onLine || window.navigator.onLine === false) {
        const loading = this.$loading()
        setTimeout(() => {
        loading.close()
        this.$message.error(this.$i18n.t('lang.lab_Online'))
        }, 500)
      }
    },
    // 清空表单
    clear(diaForm) {
      this.diaForm.gardenId = ''
      this.diaForm.typeId = ''
      this.diaForm.name = ''
      this.diaForm.answer = ''
      this.diaForm.type = 2
      setTimeout(() => {
        this.$refs.diaForm.clearValidate()
      }, 0)
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSuccess(e) {
      this.fileLists = e.raw
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.diaForm.name = ''
      this.diaForm.answer = ''
      this.diaForm.typeId = ''
      this.diaForm.gardenId = ''
      this.diaForm.type = 2
      setTimeout(() => {
        this.$refs.diaForm.clearValidate()
      }, 0)
    },
    // 更改弹框页的物业问题
    showDialogGarden() {
      console.log('点击弹框更改')
      this.diaForm.typeId = ''
      this.diaForm.gardenId = ''
      this.typelistList = []
      if (this.diaForm.type === 1) {
        this.thisDiaGardenIdList = []
        this.getDialogTypeId()
      } else {
        this.getDialogGardenId()
        this.getDialogTypeId()
      }
      setTimeout(() => {
        this.$refs.diaForm.clearValidate()
      }, 0)
      this.diaForm.gardenId = ''
      this.diaForm.typeId = ''
      if (this.editId === '') {
        this.diaForm.name = ''
        this.diaForm.answer = ''
      }
    },
    // 上传excel文件post接口
    submitUpload() {
      if (this.fileLists.length < 1) {
        this.$message.warning(this.$i18n.t('lang.key_up_file'))
      } else {
        let formData = new FormData()
        formData.append('excelFile', this.fileLists)
        let loading = this.$loading()
        this.$postFormData(`/inputKnowledge/`, formData).then(
          res => {
            loading.close()
            this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
            this.fileList = []
            this.commit()
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    },
    // 移除文件
    handleRemove() {
      this.fileList = []
      this.fileLists.length = 0
    },
    // 所属小区下拉列表获取
    getGardenId() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.thisGardenIdList = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 弹框的所属小区下拉列表获取
    getDialogGardenId() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.thisDiaGardenIdList = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 下载模板
    download() {
      if (navigator.onLine) {
        window.open(this.mouldKnowledge)
      } else {
        this.$message.error(this.$i18n.t('lang.lab_Online'))
      }
    },
    // 导出结果
    outReuslt() {
      if (navigator.onLine) {
        // Excel表头
        const tHeader = [this.$i18n.t('lang.housearea.houseName'),
          this.$i18n.t('lang.lbl_knowledge_ktName'),
          this.$i18n.t('lang.diaFormname'),
          this.$i18n.t('lang.diaFormanswer')]
        // 对应table数据的列字段名
        const filterVal = ['gname', 'ktName', 'name', 'answer']
        excelDownload(tHeader, filterVal, this.tableDataAll, '物业知识库')
      } else {
        this.$message.error(this.$i18n.t('lang.lab_Online'))
      }
    },
    // 选择物业知识百问时候全部分类下拉列表获取
    getTypeId() {
      let loading = this.$loading()
      this.$get(`knowledgeType?type=${this.type}`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.typelistList = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 选择物业知识百问时候全部分类下拉列表获取
    getDialogTypeId() {
      let loading = this.$loading()
      this.$get(`knowledgeType?type=${this.diaForm.type}`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.typeDialogList = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 更改列表页的物业问题
    showGarden() {
      if (this.type === 1) {
        this.thisGardenIdList = []
        this.thisGardenId = 0
        this.typelistValue = 0
        this.getTypeId()
      } else {
        this.typelistValue = 0
        this.getGardenId()
        this.getTypeId()
      }
    },
    // 物业知识库检索列表
    getTablelist() {
      let loading = this.$loading()
      let url
      if (this.gardenId === 0) {
        url = `/knowledge/?pageSize=${this.pageSize}&pageNo=${this.pageNo}&gardenid=${this.thisGardenId}&typeid=${this.typelistValue}&name=${this.knowledgeName}&type=${this.type}`
      } else {
        url = `/knowledge/?pageSize=${this.pageSize}&pageNo=${this.pageNo}&gardenid=${this.gardenId}&typeid=${this.typelistValue}&name=${this.knowledgeName}&type=${this.type}`
      }
      this.$get(url).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.tableData = res.list
          this.pageCount = res.pageCount
          if (this.gardenId != 0 && this.type === 2) {
            this.showEdit = true
          } else {
            this.showEdit = false
          }
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 所有的列表
    getTableAllList() {
      let loading = this.$loading()
      this.$get(`/knowledge/?pageSize=99999&pageNo=1&gardenid=${this.thisGardenId}&typeid=${this.typelistValue}&name=${this.knowledgeName}&type=${this.type}`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.tableDataAll = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    // 点击编辑
    edit(message) {
      if (this.gardenId === 0) {
        this.diaForm.type = 1
      } else {
        this.diaForm.type = 2
      }
      this.title = this.$i18n.t('lang.btn_knowledgeedit')
      this.editId = message.id
      this.diaForm.type = message.type
      this.diaForm.typeId = message.typeId
      this.diaForm.name = message.name
      this.diaForm.answer = message.answer
      if (message.gardenId === null || message.gardenId === 0) {
        this.diaForm.gardenId = ''
      } else {
        this.diaForm.gardenId = message.gardenId
      }
      this.getDialogTypeId()
      this.getDialogGardenId()
      this.isPopupPage = true
      this.saveData = JSON.stringify(this.diaForm)
    },
    // 点击添加
    add() {
      this.diaForm.gardenId = ''
      this.diaForm.typeId = ''
      this.diaForm.name = ''
      this.diaForm.answer = ''
      this.getDialogGardenId()
      this.getDialogTypeId()
      this.diaForm.type = 2
      this.title = this.$i18n.t('lang.btn_knowledge')
      this.editId = ''
      this.isPopupPage = true
    },
    save(diaForm) {
      if (this.editId === '') {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
            let params
            if (this.gardenId === 0) {
              params = {
                name: this.diaForm.name,
                answer: this.diaForm.answer,
                gardenId: this.diaForm.gardenId,
                typeId: this.diaForm.typeId,
                type: this.diaForm.type
              }
            } else {
              params = {
                name: this.diaForm.name,
                answer: this.diaForm.answer,
                gardenId: this.gardenId,
                typeId: this.diaForm.typeId,
                type: this.diaForm.type
              }
            }
            let loading = this.$loading()
            this.$post(`/knowledge`, params).then(
              res => {
                loading.close()
                // if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                  setTimeout(() => {
                    this.$refs.diaForm.clearValidate()
                  }, 0)
                // }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      } else {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            let params = {
              name: this.diaForm.name,
              answer: this.diaForm.answer,
              gardenId: this.diaForm.gardenId,
              typeId: this.diaForm.typeId,
              type: this.diaForm.type
            }
            this.$patch(`/knowledge/${this.editId}`, params).then(
              res => {
                loading.close()
                // if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                  setTimeout(() => {
                    this.$refs.diaForm.clearValidate()
                  }, 0)
                // }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      }
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
      this.getTableAllList()
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        // 添加del的url
        this.$delete('/knowledge/' + id).then(res => {
          loading.close()
          // if (res && res.errCode === 0) {
            this.$message({
              type: 'success',
              message: this.$i18n.t('lang.lab_del_success')
            })
            this.commit()
            setTimeout(() => {
              this.$refs.diaForm.clearValidate()
            }, 0)
          // }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 600px;
  }
</style>